import { default as _91_46_46_46slug_93GNwTlAMGIxMeta } from "/builds/projectowners/lawofficesystem/pages/[...slug].vue?macro=true";
import { default as authRedirectA5Wc9U2lqmMeta } from "/builds/projectowners/lawofficesystem/pages/authRedirect.vue?macro=true";
import { default as indexp7rSfWtXaaMeta } from "/builds/projectowners/lawofficesystem/pages/index.vue?macro=true";
import { default as indexqvf37UGt7CMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/CaseManagement/Edit/index.vue?macro=true";
import { default as indexq8SKhJwJfMMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/CaseManagement/index.vue?macro=true";
import { default as indexHlnJykGzjUMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/ClientManagement/Edit/index.vue?macro=true";
import { default as indexWbIHml9RBPMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/ClientManagement/index.vue?macro=true";
import { default as index37BbJcTvlAMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/index.vue?macro=true";
import { default as indexKshgiDyPR6Meta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/lawyerCasesReport/index.vue?macro=true";
import { default as indexIxfzkEVSj3Meta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/OfficeBaseManagement/index.vue?macro=true";
import { default as indexA0a5EYrrSKMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/ReceiptManagement/Edit/index.vue?macro=true";
import { default as indexRX43W7T8BBMeta } from "/builds/projectowners/lawofficesystem/pages/lawOffice/ReceiptManagement/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93GNwTlAMGIxMeta?.name ?? "slug",
    path: _91_46_46_46slug_93GNwTlAMGIxMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93GNwTlAMGIxMeta || {},
    alias: _91_46_46_46slug_93GNwTlAMGIxMeta?.alias || [],
    redirect: _91_46_46_46slug_93GNwTlAMGIxMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: authRedirectA5Wc9U2lqmMeta?.name ?? "authRedirect",
    path: authRedirectA5Wc9U2lqmMeta?.path ?? "/authRedirect",
    meta: authRedirectA5Wc9U2lqmMeta || {},
    alias: authRedirectA5Wc9U2lqmMeta?.alias || [],
    redirect: authRedirectA5Wc9U2lqmMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/authRedirect.vue").then(m => m.default || m)
  },
  {
    name: indexp7rSfWtXaaMeta?.name ?? "index",
    path: indexp7rSfWtXaaMeta?.path ?? "/",
    meta: indexp7rSfWtXaaMeta || {},
    alias: indexp7rSfWtXaaMeta?.alias || [],
    redirect: indexp7rSfWtXaaMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexqvf37UGt7CMeta?.name ?? "lawOffice-CaseManagement-Edit",
    path: indexqvf37UGt7CMeta?.path ?? "/lawOffice/CaseManagement/Edit",
    meta: indexqvf37UGt7CMeta || {},
    alias: indexqvf37UGt7CMeta?.alias || [],
    redirect: indexqvf37UGt7CMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/CaseManagement/Edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexq8SKhJwJfMMeta?.name ?? "lawOffice-CaseManagement",
    path: indexq8SKhJwJfMMeta?.path ?? "/lawOffice/CaseManagement",
    meta: indexq8SKhJwJfMMeta || {},
    alias: indexq8SKhJwJfMMeta?.alias || [],
    redirect: indexq8SKhJwJfMMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/CaseManagement/index.vue").then(m => m.default || m)
  },
  {
    name: indexHlnJykGzjUMeta?.name ?? "lawOffice-ClientManagement-Edit",
    path: indexHlnJykGzjUMeta?.path ?? "/lawOffice/ClientManagement/Edit",
    meta: indexHlnJykGzjUMeta || {},
    alias: indexHlnJykGzjUMeta?.alias || [],
    redirect: indexHlnJykGzjUMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/ClientManagement/Edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexWbIHml9RBPMeta?.name ?? "lawOffice-ClientManagement",
    path: indexWbIHml9RBPMeta?.path ?? "/lawOffice/ClientManagement",
    meta: indexWbIHml9RBPMeta || {},
    alias: indexWbIHml9RBPMeta?.alias || [],
    redirect: indexWbIHml9RBPMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/ClientManagement/index.vue").then(m => m.default || m)
  },
  {
    name: index37BbJcTvlAMeta?.name ?? "lawOffice",
    path: index37BbJcTvlAMeta?.path ?? "/lawOffice",
    meta: index37BbJcTvlAMeta || {},
    alias: index37BbJcTvlAMeta?.alias || [],
    redirect: index37BbJcTvlAMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/index.vue").then(m => m.default || m)
  },
  {
    name: indexKshgiDyPR6Meta?.name ?? "lawOffice-lawyerCasesReport",
    path: indexKshgiDyPR6Meta?.path ?? "/lawOffice/lawyerCasesReport",
    meta: indexKshgiDyPR6Meta || {},
    alias: indexKshgiDyPR6Meta?.alias || [],
    redirect: indexKshgiDyPR6Meta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/lawyerCasesReport/index.vue").then(m => m.default || m)
  },
  {
    name: indexIxfzkEVSj3Meta?.name ?? "lawOffice-OfficeBaseManagement",
    path: indexIxfzkEVSj3Meta?.path ?? "/lawOffice/OfficeBaseManagement",
    meta: indexIxfzkEVSj3Meta || {},
    alias: indexIxfzkEVSj3Meta?.alias || [],
    redirect: indexIxfzkEVSj3Meta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/OfficeBaseManagement/index.vue").then(m => m.default || m)
  },
  {
    name: indexA0a5EYrrSKMeta?.name ?? "lawOffice-ReceiptManagement-Edit",
    path: indexA0a5EYrrSKMeta?.path ?? "/lawOffice/ReceiptManagement/Edit",
    meta: indexA0a5EYrrSKMeta || {},
    alias: indexA0a5EYrrSKMeta?.alias || [],
    redirect: indexA0a5EYrrSKMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/ReceiptManagement/Edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexRX43W7T8BBMeta?.name ?? "lawOffice-ReceiptManagement",
    path: indexRX43W7T8BBMeta?.path ?? "/lawOffice/ReceiptManagement",
    meta: indexRX43W7T8BBMeta || {},
    alias: indexRX43W7T8BBMeta?.alias || [],
    redirect: indexRX43W7T8BBMeta?.redirect || undefined,
    component: () => import("/builds/projectowners/lawofficesystem/pages/lawOffice/ReceiptManagement/index.vue").then(m => m.default || m)
  }
]